<template>
  <b-form-row>
    <b-modal size="sm" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

      <b-form @submit.prevent="save">
        <b-card>
          <b-form-row>

            <lg-form-const-select textField="descricao" valueField="id" label="Status:" v-model="form.statusParecer"
              :options="optionsFilterSituacao" />


            <b-form-group label="Tipo Coleta:">
              <b-form-checkbox v-model="form.tipoColeta" :value="2" :unchecked-value="1">Restrita</b-form-checkbox>
            </b-form-group>

            <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
              v-model="form.dataAgendamento" label="Data Agendamento:" cols="12" sm="12" />


            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
              <b-button id="salcarSolicitacaoInventario" class=" my-2" size="sm" pill variant="success" @click="save">
                <b-icon icon="check-circle" />
                <b-tooltip target="salcarSolicitacaoInventario" title="Salvar"></b-tooltip>

              </b-button>

              <b-button id="cancelarSolicitacaoInventario" class=" my-2 ml-2" size="sm" pill variant="danger"
                @click="cancelar">
                <b-icon icon="x-circle" />
                <b-tooltip target="cancelarSolicitacaoInventario" title="Cancelar"></b-tooltip>

              </b-button>
            </b-col>
            <b-col cols="3"></b-col>

          </b-form-row>



        </b-card>
      </b-form>
    </b-modal>
  </b-form-row>
</template>
<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";

import { FormResourceMixin } from "@/core/mixins/resource";
import StatusSolicitacaoInventarioIBPEnum from "@/core/utils/StatusSolicitacaoInventarioIBPEnum";

export default {
  components: {
    LgFormDate,
    LgFormConstSelect
  },


  mixins: [FormResourceMixin],

  props: {
    id: Number,
    prefix: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showModal: true,
      title: "Parecer",
      optionsFilterSituacao: [],
      form: {
        dataAgendamento: "",
        tipoColeta: null,
        statusParecer: { id: StatusSolicitacaoInventarioIBPEnum.APROVADO_RFID.cod }
      },
    };
  },


  async beforeMount() {

    this.$service = new ResourceService(`/api/solicitacaoinventario`);

    this.$service.get("findStatus").then(response => {
      this.optionsFilterSituacao = response.data.content;
    });

    if (this.id) {
      const { data } = await this.$service.findById(this.id);

      this.form = data;
      this.form.tipoColeta = this.form.tipoColetaColetor && this.form.tipoColetaColetor.id ? this.form.tipoColetaColetor.id : null;
    }

    if (this.form.status.id != StatusSolicitacaoInventarioIBPEnum.APROVADO_RFID.cod && this.form.status.id != StatusSolicitacaoInventarioIBPEnum.APROVADO.cod && this.form.status.id != StatusSolicitacaoInventarioIBPEnum.REPROVADO.cod)
      this.form.statusParecer = StatusSolicitacaoInventarioIBPEnum.APROVADO_RFID.cod;
    else
      this.form.statusParecer = this.form.status.id;


  },

  methods: {
    validateState(field) {
      if (!field.$dirty) {
        return null
      }
      return field.$invalid ? false : true
    },
    cancelar() {
      this.$emit("close");
    },

    async save() {

      try {

        await this.$saveResource(this.form, "", false);
        this.cancelar();
      }
      catch (error) {
        this.$notify({
          type: "danger",
          message: error,
        });

      }


    },

  },
};
</script>
